import { mapValues } from 'lodash'

import { http } from '@/services/http.js'
import { mask } from '@/utils/mask.js'

export function getAuthTokenFn(userToken) {
  return (callback) => {
    return http.post(`/api/artist-identity/${userToken}/authentication-token/`)
      .then(response => {
        callback(response.data.value)
      })
      .catch(err => {
        callback(null, err)
        throw err
      })
  }
}

export function formatErrors(data) {
  // Our Hyperwallet endpoints can return different kinds of errors
  // Django validation errors:
  // `{city: ["This field may not be blank."]}`
  // errors from Hyperwallet:
  // `{errors: [{fieldName: "city", message: "is invalid length or format.", ...}]}`

  const errors = data && data.errors
  return Array.isArray(errors)
    ? formatHWErrors(errors)
    : data
}

function formatHWErrors(errors) {
  return errors.reduce((acc, cur, idx) => {
    acc[cur.fieldName ?? idx] = cur.message
    return acc
  }, {})
}


export const sensitiveFields = {
  user: ['governmentId', 'employerId'],
}

export function maskUser(data) {
  return mapValues(data, (v, k) => {
    return sensitiveFields.user.includes(k)
      ? mask(v, {showLast: 2})
      : v
  })
}
